import { isBefore } from "date-fns"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { getPaginatedNodes } from "@/utils/getPaginatedNodes"

const graphQLFragments = {
    agreement: graphql(`
        fragment IsAgreementInLeaveSupplierProcess_Agreement on AgreementType {
            validFrom
            supplyPoint {
                id
            }
        }
    `),
    // TODO: Move this fragment in the lifecycleProcesses entity folder
    leaveSupplierProcesses: graphql(`
        fragment IsAgreementInLeaveSupplierProcess_LeaveSupplierProcesses on LeaveSupplierProcessType {
            id
            status
            supplyPoints(first: 10) {
                edges {
                    node {
                        id
                    }
                }
            }
        }
    `),
}

type IsAgreementInLeaveSupplierProcessProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
    leaveSupplierProcesses: FragmentOf<typeof graphQLFragments.leaveSupplierProcesses>[]
}

export function isAgreementInLeaveSupplierProcess(props: IsAgreementInLeaveSupplierProcessProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    // A supply point can have several supply contract in case of win-back clients.
    // As a leave supplier process is associated to a supply point, we can't determine to which supply contract the process belongs to.
    // Therefore, we need to check if the agreement of the supply contract is in the future to avoid returning a false positive.
    if (agreement.validFrom && isBefore(new Date(), agreement.validFrom)) {
        return false
    }

    const leaveSupplierProcesses = props.leaveSupplierProcesses.map((process) =>
        readFragment(graphQLFragments.leaveSupplierProcesses, process)
    )

    const leaveSupplierProcess = leaveSupplierProcesses.find((process) => {
        const processSupplyPoints = getPaginatedNodes(process.supplyPoints)

        return processSupplyPoints.some(
            (supplyPoint) => supplyPoint.id === agreement.supplyPoint?.id
        )
    })

    return leaveSupplierProcess?.status === "PENDING"
}

isAgreementInLeaveSupplierProcess.fragments = graphQLFragments
